import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const ButtonContainer = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing.xSmall,
}));

export const ButtonWrapper = styled.div(() => ({
    display: "inline-block",
    flex: 1,
}));

export const ButtonContent = styled.div({
    display: "flex",
    width: "100%",
    flexDirection: "column",
});

export const DisabledText = styled.div(({ theme }) => ({
    marginTop: theme.spacing.small,
    display: "flex",
    gap: theme.spacing.xSmall,
}));

export const BankOfferEMITag = styled(Text)(({ theme }) => ({
    padding: `${theme.spacing.xxSmall} calc(${theme.spacing.xxxSmall} * 3)`,
    background: `linear-gradient(90deg, #EEE9FF 0%, #FFF 100%)`,
    borderRadius: theme.cornerRadius.xxSmall,
    marginBottom: theme.spacing.small,
}));
